import React from "react";
const Update = React.forwardRef(({ filled = false, size = 20, ...props }, ref) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M14.81 17.0999C14.8 17.0999 14.79 17.0999 14.78 17.0999H8.10999C6.12999 16.9599 5.25 15.4499 5.25 14.0999C5.25 12.9699 5.87001 11.73 7.20001 11.27C6.90001 9.76999 7.27001 8.36999 8.26001 7.32999C9.45001 6.07999 11.36 5.59 13 6.09C14.46 6.54 15.51 7.71 15.92 9.34C17.17 9.69 18.16 10.67 18.57 12C19.03 13.52 18.61 15.08 17.47 16.07C16.75 16.73 15.8 17.0999 14.81 17.0999ZM8.14001 12.5999C7.12001 12.6899 6.75 13.4599 6.75 14.0999C6.75 14.7499 7.12 15.5299 8.16 15.5999H14.78C15.43 15.5999 16 15.38 16.46 14.95C17.3 14.22 17.35 13.17 17.13 12.43C16.91 11.69 16.28 10.8499 15.19 10.7199C14.86 10.6799 14.6 10.4299 14.54 10.0999C14.32 8.76995 13.61 7.86 12.55 7.53C11.46 7.19 10.13 7.53997 9.34 8.36997C8.56 9.17997 8.39 10.3299 8.84 11.5999C8.98 11.9899 8.78001 12.42 8.39001 12.56C8.31001 12.59 8.18001 12.6099 8.14001 12.5999Z"
      fill={filled ? "white" : "#4B4E4F"}
    />
    <path
      d="M9 22.75C4.73 22.75 1.25 19.27 1.25 15C1.25 14.59 1.59 14.25 2 14.25C2.41 14.25 2.75 14.59 2.75 15C2.75 17.96 4.80999 20.44 7.57999 21.09L7.31 20.64C7.1 20.28 7.21001 19.82 7.57001 19.61C7.92001 19.4 8.39001 19.51 8.60001 19.87L9.64999 21.62C9.78999 21.85 9.79 22.14 9.66 22.37C9.52 22.6 9.27 22.75 9 22.75Z"
      fill={filled ? "white" : "#4B4E4F"}
    />
    <path
      d="M21.9999 9.75C21.5899 9.75 21.2499 9.41 21.2499 9C21.2499 6.04 19.1899 3.55997 16.4199 2.90997L16.6899 3.35999C16.8999 3.71999 16.7899 4.18001 16.4299 4.39001C16.0799 4.60001 15.6099 4.49 15.3999 4.13L14.3499 2.38C14.2099 2.15 14.2099 1.86 14.3399 1.63C14.4699 1.39 14.7199 1.25 14.9899 1.25C19.2599 1.25 22.7399 4.73 22.7399 9C22.7499 9.41 22.4099 9.75 21.9999 9.75Z"
      fill={filled ? "white" : "#4B4E4F"}
    />
  </svg>
));
Update.displayName = 'Update';

export default Update;
